import { FormBuilder, FormGroup } from "@angular/forms";
import moment from "moment";

export class Formulario {
    static prepareValueToForm(
        model: any,
        value: any = {},
        datas?: any,
        relacionamentos?: any,
        checkbox?: any,
        exclude?: any,
    ): any {
        let data: any = {};
        if (exclude) exclude.forEach((v: any) => delete model[v]);

        Object.keys(model).filter((key) => {
            if (
                relacionamentos &&
                relacionamentos.findIndex((v: any) => v === key) !== -1 &&
                value[key] !== null
            ) {
                if (value[key] !== undefined)
                    data[key] = value[key]["Id"] || null;
            } else if (value.hasOwnProperty(key)) {
                data[key] = value[key];
            }
            if (datas != null && datas.length > 0) {
                datas.forEach((v: any) => {
                    if (value[v] != null) {
                        // let myMoment: moment.Moment = (moment as any)(data[v]);
                        let myMoment = moment(data[v])
                        data[v] = myMoment.toDate();
                    }
                });
            }
            if (checkbox != null && checkbox.length > 0) {
                checkbox.forEach((v: any) => {
                    data[v] = !(
                        value[v] == null ||
                        value[v] === "N" ||
                        value[v] === false
                    );
                });
            }
        });
        return data;
    }

    static createForm(
        obj: any = {},
        fb: FormBuilder,
        validators: any = [],
        exclude?: any,
    ): FormGroup {
        let data: any = {};
        if (exclude) exclude.forEach((v: any) => delete obj[v]);

        Object.keys(obj).forEach((key) => {
            const validationIndex = validators.findIndex(
                (f: any) => f.campo === key,
            );
            if (validationIndex !== -1) {
                data[key] = fb.control(
                    "",
                    validators[validationIndex].validation,
                );
            } else {
                data[key] = fb.control("");
            }
        });
        return fb.group(data);
    }

    static parseForm(
        obj: any = {},
        value: any = {},
        relacionamentos?: Array<{ chave: any; referencia: any }>,
        mascaras?: string[],
        datas?: string[],
        checkbox?: string[],
        checkboxNovo?: string[],
        exclude?: any,
    ): any {
        let data: any = {};
        if (exclude) exclude.forEach((v: any) => delete obj[v]);

        Object.keys(value).forEach((key) => {
            if (value[key] === undefined || value[key] === null)
                value[key] = "";
            typeof obj[key] === "number"
                ? (data[key] =
                      Number.parseFloat(
                          value[key].toString().replace(",", "."),
                      ) || 0)
                : (data[key] = value[key].toString().includes("(")
                      ? value[key]
                      : value[key].toString() || "");
        });
        if (relacionamentos != null && relacionamentos.length > 0) {
            relacionamentos.forEach((v) => {
                let nome = v.chave + "@xdata.ref";
                if (
                    data[v.chave] &&
                    data[v.chave].toString().match(/\d/g) &&
                    data[v.chave] != 0
                ) {
                    if (data[v.chave].toString().includes("(")) {
                        data[nome] = data[v.chave];
                    } else {
                        data[nome] = v.referencia + "(" + data[v.chave] + ")";
                    }
                    delete data[v.chave];
                } else {
                    delete data[nome];
                    delete data[v.chave];
                }
            });
        }
        if (mascaras != null && mascaras.length > 0) {
            mascaras.forEach((value) => {

                if (!data[value]) return;

                if (data[value].length >= 14) {
                    data[value] = this.removeMascaraAlfanumerica(data[value]);
                } else {
                    data[value] = this.removeMascara(data[value]);
                }
            });
        }
        if (datas != null && datas.length > 0) {
            datas.forEach(
                (value) => (data[value] = this.dataParaString(data[value])),
            );
        }
        if (checkbox != null && checkbox.length > 0) {
            checkbox.forEach((value) => {
                data[value] =
                    data[value] === true || data[value] === "true" ? "S" : "N";
            });
        }
        for (let key in data) {
            if (data[key] === "") data[key] = null;
        }
        if (checkboxNovo != null && checkboxNovo.length > 0) {
            checkboxNovo.forEach((value) => {
                data[value] =
                    data[value] === "TRUE" ||
                    data[value] === true ||
                    data[value] === "true";
            });
        }
        if (data["Id"] === null || data["Id"] === "") data["Id"] = 0;
        return data;
    }

    static removeMascara(value: string = "") {
        if (value == null || value.trim() === "") return "";
        const match = value.match(/\d/g);
        return match ? match.join("") : ""
        //  value.match(/\d/g)!.join("");
    }

    static removeMascaraAlfanumerica(value: string = "") {
        if (value == null || value.trim() === "") return "";
        // Procura por números (0-9) e letras (a-z, A-Z)
        const match = value.match(/[a-zA-Z0-9]/g);
        return match ? match.join("") : "";
    }

    static dataParaString(data: any) {
        if (data === undefined || data === null || data === "") return "";
        if (typeof data === "string") return data;
        let mes = (data.getUTCMonth() + 1).toString();
        if (mes.length === 1) mes = "0" + mes;
        let dia = data.getUTCDate().toString();
        if (dia.length === 1) dia = "0" + dia;
        return data.getUTCFullYear() + "-" + mes + "-" + dia;
    }

    static dataParaStringComHora(data: any) {
        if (data === undefined || data === null || data === "") return "";
        if (typeof data === "string") return data;
        let mes = (data.getUTCMonth() + 1).toString();
        if (mes.length === 1) mes = "0" + mes;
        let dia = data.getUTCDate().toString();
        if (dia.length === 1) dia = "0" + dia;
        let hora = data.getUTCHours();
        if (hora.length === 1) hora = "0" + hora;
        let minuto = data.getUTCMinutes();
        if (minuto.length === 1) minuto = "0" + minuto;
        let segundos = data.getUTCSeconds();
        if (segundos.length === 1) segundos = "0" + segundos;
        return (
            data.getUTCFullYear() +
            "-" +
            mes +
            "-" +
            dia +
            " " +
            hora +
            ":" +
            minuto +
            ":" +
            segundos +
            ".000000"
        );
    }

    static verifyIfExistsValues(value: any = {}) {
        let hasValues = false;
        Object.keys(value).forEach((key) => {
            if (value[key] !== "") hasValues = true;
        });
        return hasValues;
    }

    static stringParaData(data: any) {
        if (data == null) return data;
        // let myMoment: moment.Moment = (moment as any)(data);
        let myMoment = moment(data)
        return myMoment.toDate();
    }
}